import React from 'react';
import { motion } from 'framer-motion';
import { Target, Megaphone, Cpu, Zap } from 'lucide-react';
const steps = [{
  id: 1,
  icon: Target,
  title: 'Brands define needs',
  description: 'Input audience demographics, campaign goals, budget, and timeline.'
}, {
  id: 2,
  icon: Megaphone,
  title: 'Organizers define offering',
  description: 'Share event details, audience data, and sponsorship opportunities.'
}, {
  id: 3,
  icon: Cpu,
  title: 'SponsrAI matches',
  description: 'Our AI scores relevance, removes noise, and highlights best-fit opportunities.'
}, {
  id: 4,
  icon: Zap,
  title: 'Connect & collaborate',
  description: 'Make faster decisions and build stronger, data-backed partnerships.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-slate-950 relative overflow-hidden" data-id="element-770">
      {/* Connecting Line Background */}
      <div className="absolute top-1/2 left-0 w-full h-0.5 bg-slate-800 hidden lg:block -translate-y-1/2" data-id="element-771" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-772">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-773">
          <span className="text-cyan-500 font-semibold tracking-wider uppercase text-sm" data-id="element-774">
            The Solution
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-2 mb-4" data-id="element-775">
            Meet SponsrAI
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-776">
            A smart sponsorship platform that connects brands and organizers
            using AI-based matching.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-777">
          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative" data-id="element-778">
              <div className="bg-slate-900 border border-slate-800 p-8 rounded-2xl h-full hover:border-cyan-500/50 transition-colors duration-300" data-id="element-779">
                <div className="absolute -top-6 left-8 bg-slate-950 p-2 rounded-full border border-slate-800 text-cyan-500 font-bold text-xl w-12 h-12 flex items-center justify-center z-20" data-id="element-780">
                  {step.id}
                </div>
                <div className="mt-6 mb-4 text-cyan-400" data-id="element-781">
                  <step.icon size={32} data-id="element-782" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-783">
                  {step.title}
                </h3>
                <p className="text-slate-400" data-id="element-784">{step.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}